<template>
  <div class="layout my">
    <div class="my_head">
      <div class="my_head_top">
        <div class="user_info">
          <div class="user_left">
            <div class="user_img_div"> 
              <img v-if="user && user.avatarUrl" :src="user.avatarUrl" />
              <img src="@/assets/img/avatar.png" v-else />

              <div class="user_role">
                <span v-if="user.userRole === 0">游客</span>
                <span v-if="user.userRole === 1 ">普通买家</span>      
                <span v-if="user.userRole === 2 ">专业买家</span>
                <span v-if="user.userRole === 3">行业名人</span>
                <span v-if="user.userRole === 4">展商</span>
              </div>
            </div>
            <div class="user_info_top" :class="{no_comp:!user.company,tag_br:isbr}" v-if="user.userRole>1 ">
              <p class="user_name van-ellipsis">
                {{user.name || user.nickName}}
                <span>{{user.jobTitle}}</span>
              </p>
              <p class="company_name" >{{user.company}}</p>
              <div class="interest">
                <div v-for="(item,index) in getCateList(user.category)" :key="index">
                 <span>{{item}}</span>
                </div>
              </div>
            </div>
            <div class="user_info_top comm_user" v-else>
              <p class="user_name" v-if="user.nickName||user.name">{{user.nickName?user.nickName:user.name}}</p>
              <p class="reg_btn" @click="goToreg">申请成为专业买家</p>
            </div>
            <div class="user_set">
              <van-button class="user_edit" @click="editData" color="#415374">编辑个人资料</van-button>
              <van-button class="user_seticon" @click="editIcon" color="#415374">
                <van-icon  class="iconfont icon-shezhi"  size="0.3rem" />
              </van-button>
            </div>
          </div>
          <p class="uset_text" :style="user.userRole>1?'':'border:none'">简介：{{user.introduction}}</p>
          <div class="sign" v-if="user.userRole > 1">
            <div class="sign_text ">
              <p class="van-ellipsis">供需：{{user.business?getBuContetn(user.business):''}}</p>
              <i class="sign_edit iconfont icon-bianji" @click="editSupply"></i>
            </div>
            <div class="sign_img" v-if="user.business">
              <img v-for="(item,index) in getBuImgList(user.business)" @click="viewImg(getBuImgList(user.business),index)" :key="index"
                :src="item"
                   v-load="'oMyBus'"
              />
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div class="my_content">
      <van-tabs
        class="content_nav"
        @change="tabsChange"
        animated
        :lazy-render="false"
        line-height="0.03rem"
        line-width="1.38rem"
        color="#f85b0f"
        title-inactive-color="#fff"
        title-active-color="#f85b0f"
        v-model="activeName"
        sticky
        swipeable
      >
        <!-- 产品内容 -->
        <van-tab name="product">
          <template #title>
            <div class="con_nav_title">
              <p class="title_count">{{productCount}}</p>
              <p class="title_text">产品</p>
            </div>
          </template>
          <collectProduct ref="collectProduct"></collectProduct> 
        </van-tab>
        <!-- 展商内容 -->
        <van-tab name="ex">
          <template #title>
            <div class="con_nav_title">
              <p class="title_count">{{collectExhibitorCount}}</p>
              <p class="title_text">展商</p>
            </div>
          </template>
           <collectExhibitor ref="collectExhibitor"></collectExhibitor>
        </van-tab>
        <!-- 话题内容 -->
        <van-tab name="topic">
          <template #title>
            <div class="con_nav_title">
              <p class="title_count">0</p>
              <p class="title_text">话题</p>
            </div>
          </template>
          <!-- <van-list
              class="topic_con"
              v-model="topicLoading"
              :finished="topicFinished"
              finished-text="没有更多了"
              @load="topicLoad"
            >
          </van-list>-->
        </van-tab>
      </van-tabs>
    </div>
    <commNotRegMask v-if="!user.userRole"></commNotRegMask>
    <layoutFooter></layoutFooter>
  </div>
</template>

<script>
import {ImagePreview} from "vant";
import commNotRegMask from "@/components/comm-notreg-mask";
import { mapGetters, mapActions } from "vuex";
import layoutFooter from "@components/layout-footer";
import collectProduct from "./components/collect-product";
import collectExhibitor from "./components/collect-exhibitor";
export default {
  name: "my",
  components: {
    layoutFooter,
    collectProduct,
    collectExhibitor,
    commNotRegMask
  },
  data() {
    return {
      uRole:4,        //测试使用
      activeName: "product",

      topicLoading: false, //话题动态加载状态
      topicFinished: false, //话题加载是否完成状态
      topicList: [], //话题列表
      
      isbr:false,
      // helpLoading:false,  //助力动态加载状态
      // helpFinished:false, //助力加载是否完成状态
      // helpList:[],        //助力列表
    };
  },
  computed: {
    ...mapGetters({
      user: "getUserInfo" // 用户身份类别 0：游客、1：普通买家、2：专业买家、3：行业名人、4：展商
    }),
    //展商总数
    productCount() {
      return this.$refs.collectProduct.totalCount;
    },
    //产品总数
    collectExhibitorCount() {
      return this.$refs.collectExhibitor.totalCount;
    },
    
  },
  created() {
    this.getUser();
  },
  methods: {
    ...mapActions({
      getUser:'login/getUser',
    }),
    //得到供需内容
    getBuContetn(str){
      return JSON.parse(str).content
    },
    //得到供需图片List
    getBuImgList(str){
      return JSON.parse(str).imgList
    },
    //预览图片
    viewImg(imgList,index){
      ImagePreview({images: imgList, startPosition: index});
    },
    getCateList(str){
      if(!str) return;
      let option=JSON.parse(str);
      let cateList=[];
      option.forEach(el => {
          el.Lists.forEach(model=>{
            cateList.push(model.Value);
          })
      });
      this.getElHeight();
      return cateList
    },
    //获取元素高度
    getElHeight(){
      this.$nextTick(()=>{
        let h=$('.interest').height()
        if(h>30){
          this.isbr=true;
        }
      })
    },
    //产品加载
    proLoad() {
    
    },
    //话题加载
    topicLoad() {
   
    },
    //展商加载
    cardLoad() {
     
    },
    // //助力加载
    // helpLoad(){
    // 
    // },
    //tab标签页改变
    tabsChange(data) {
      this.$toast.clear();
      switch (data) { 
        case "product": {
          this.$refs.collectProduct.tabActive();
          break;
        }
        case "topic": {
          this.$toast({
            message: "此功能暂未开放",
            className: "toastzwkf"
          });
          break;
        }
        case "ex": {
          this.$refs.collectExhibitor.tabActive();
          break;
        }
        case "help": {
          break;
        }
        default:
          break;
      }
    },
    //个人资料修改
    editData() {
      this.$router.push("/editPersonData");
    },
    //设置按钮点击
    editIcon() {
      this.$toast({
        message: "此功能暂未开放",
        className: "toastzwkf"
      });
    },
    //供需修改
    editSupply() {
      this.$router.push("/editSupply");
    },
    //普通用户认证专业买家
    goToreg() {
      if(this.user.auditState==0){
        this.$toast.fail('认证资料正在审核中，请耐心等待...');
        return 
      }
      this.$router.push("/editAuerbach");
    }
  }
};
</script>
<style lang="scss" scoped>
.my {
  background: #131825 75%;
}
.my_head {
  width: 100%;
  padding: 0.2rem 0.24rem 0.5rem;
  background: url("../../../static/images/my_headbg.jpg");
  background-size: cover;
  min-height:calc(100vh - 66vh);
  .my_head_top {
    color: #fff;
    .user_info {
      position: relative;
      .user_left {
        display: flex;
        margin-bottom: 0.24rem;
        .user_img_div {
          width: 1.1rem;
          height: 1.26rem;
          margin-right: 0.19rem;
          position: relative;
          text-align: center;
          img {
            width: 1.1rem;
            height: 1.1rem;
            border-radius: 50%;
            border: 0.03rem solid #fff;
          }
          .user_role{
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            bottom: 0;
            left: 0.05rem;
            height: 0.32rem;
            border-radius: 0.03rem;
            width: 1rem;
            background: #f85b0f;
            color: #fffefe;
            span {
              font-size: 0.2rem;
              width: 100%;
            }
          }
        }
        .user_info_top {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p{
            line-height: 1.1;
            width: calc(100% - 2.6rem);
          }
          &.no_comp {
            justify-content: center;
          }
          &.comm_user {
            justify-content: space-between;   
            padding-top: 0.35rem;
            padding-bottom: 0.02rem;
            .reg_btn {
              color: #f85b0f;
              font-size: 0.2rem;
            }
          }
          &.tag_br{
            justify-content:flex-start;
            .user_name{
              margin-bottom: 0.05rem;
            }
            .company_name{
              margin-bottom: 0.13rem;
              line-height: 2;
            }
            .interest{
              margin-bottom: -0.1rem;
              div{
                margin-bottom: 0.1rem;  
              }
            }
          }
          .user_name {
            font-size: 0.3rem;
            span {
              font-size: 0.22rem;
              margin-left: 0.19rem;
            }
          }
          .company_name {
            font-size: 0.22rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .interest {
            display: flex;
            flex-wrap: wrap;
            div{
              margin-right: 0.1rem;
              display: flex;
              justify-items: center;
              align-items: center;
              text-align: center;
              height: 0.32rem;
              background: #333d56;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              border-radius: 0.03rem;
              padding: 0 0.11rem;
              span{
                font-size: 0.2rem;
              }
            }
          }
        }
        .user_set {
          position: absolute;
          right: 0;
          top: 0;
          width: 2.46rem;
          display: flex;
          .user_edit {
            height: 0.56rem;
            line-height: 0;
            padding: 0 0.14rem;
            border-radius: 0.07rem;
          }
          .user_seticon {
            border-radius: 0.07rem;
            height: 0.56rem;
            line-height: 0;
            padding: 0 0.13rem;
            margin-left: 0.1rem;
            &::v-deep .van-button__text{
              .iconfont{
                transform: scale(1.6);
              }
            }
          }
        }
      }
      .sign {
        position: relative;
        .sign_text{
          display: flex;
          justify-content: space-between;
          margin-top: 0.23rem;
          .sign_edit {
            font-size: 0.32rem;
            transform: scale(1.5);
          }
        }
        
        p {
        }
        .sign_img {
          display: flex;
          img {
            width: 1.1rem;
            height: 1.1rem;
            margin-right: 0.1rem;
            margin-top: 0.15rem;
            display: block;
            // object-fit: cover;
          }
        }
      }
      .uset_text {
        line-height: 0.38rem;
        color: #bfbfbf;
        padding-bottom: 0.2rem;
        font-size: 0.26rem;
        border-bottom: 1px solid #415374;
      }
      
    }
  }
}
.my_content {
  background: #131825;
  &::v-deep .content_nav {
    > div:first-child {
      background: #25324b;
    }
    .van-sticky {
      background: #131825;
      padding-bottom: 0.15rem;
      border-radius: 0.16rem 0.16rem 0 0;
      overflow: hidden;
    }
    .van-tabs__wrap {
      height: 0.91rem;
      padding: 0 0.24rem;
      background: #131825;
      &::after {
        border-top: none;
        border-color: #2d3854;
      }
    }
    .van-tabs__nav {
      border-radius: 0.16rem 0.16rem 0 0;
      background: #131825;
      .con_nav_title {
        text-align: center;
        display: flex;
        flex-direction: column;
        line-height: 0.32rem;
        height: 100%;
        justify-content: center;
        .title_text {
          // letter-spacing: 1px;
        }
      }
    }
    .van-list__finished-text,
    .van-list__loading {
      width: 100%;
      line-height: 0.3rem;
      margin:0.45rem auto 0.15rem;
      font-size: 0.24rem;
    }
    .van-tabs__content {
      min-height: 3rem;
    }
  }
}
</style>
